import { Input, Layout } from 'antd';
import Icon from 'assets/Icons';
import Box from 'components/Box';
import Button from 'components/Button';
import Text from 'components/Text';
import Sidebar from 'components/layout/Sidebar';
import colorTheme from 'constants/color';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import AppointmentDatePicker from 'features/report/pages/ReportPage/components/DatePicker';
import SwitchCalendarType from 'features/report/pages/ReportPage/components/SwitchCalendarType';
import { debounce } from 'lodash';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import SelectFromToOptions from '../components/SelectFromToOptions';
import TableGiftCards from '../components/TableGiftCards';
import giftCardsActions from '../services/actions';
import giftCardsSelectors from '../services/selectors';
import Modal from 'components/Modal';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { AxiosResponse } from 'axios';
import giftCardsApis from '../services/apis';
import toast from 'utils/toast';
import shopSelectors from 'services/shop/selectors';
import GiftCardsV2 from './GiftCardsV2';

interface IGiftCards {

}
export const GIFT_CARDS = 'GIFT_CARDS';
const PAGE_SIZE = 20;
const GiftCards: FC<IGiftCards> = () => {
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const dispatch = useAppDispatch();
    const [resetTime, setResetTime] = useState<number>();
    const [status, setStatus] = useState<string>('ACTIVE');
    const [searchText, setSearchText] = useState<string>();
    const [resetTimeChecked, setResetTimeChecked] = useState<string[]>([]);
    const dataAppointment = giftCardsSelectors.getParams()?.[GIFT_CARDS];
    const totalElements = giftCardsSelectors.getTotalElements();
    const resetGiftCardStatus = giftCardsSelectors.getResetTimeGiftCardStatus();
    const setLoadingPage = useSetLoadingPage();
    const versionUI = shopSelectors.data.versionUI();


    useEffect(() => {
        if (resetGiftCardStatus) {
            setResetTimeChecked([]);
            dispatch(giftCardsActions.resetGiftCardDetail.fail(false));
        }
    }, [resetGiftCardStatus]);
    useEffect(
        () => {
            if (dataAppointment?.startTime && dataAppointment?.endTime) {
                const payload = {
                    page: 1,
                    size: PAGE_SIZE,
                    resetNumber: resetTime,
                    keySearch: searchText,
                    startDate: dataAppointment?.startTime,
                    endDate: dataAppointment?.endTime,
                    status: status === 'ACTIVE' ? true : false
                };
                dispatch(giftCardsActions.getListGiftCard.fetch(payload));
            }
        }, [dataAppointment, resetTime, searchText, status]
    );

    useEffect(() => {
        dispatch(giftCardsActions.setParams({
            [GIFT_CARDS]: {
                startTime: dataAppointment?.startTime || moment().format(DATE_FORMAT),
                endTime: dataAppointment?.endTime || moment().format(DATE_FORMAT)
            }
        }));
        dispatch(giftCardsActions.getSummaryGiftCards.fetch());
    }, []);

    const handleChangeResetTime = (value: number) => {
        setResetTime(value);
    };
    const handleSearch = debounce((event: any) => {
        setSearchText(event?.target?.value);
    }, 300);
    const onReset = () => setVisibleConfirm(true);

    const handleReset = async () => {
        setVisibleConfirm(false);
        setLoadingPage(true);
        try {
            const resData: AxiosResponse<{ data: any }> = await giftCardsApis.resetGiftCardDetail(resetTimeChecked);
            if (resData?.data?.data) {
                toast.success('Successful');
                const payload = {
                    page: 1,
                    size: PAGE_SIZE,
                    resetNumber: resetTime,
                    keySearch: searchText,
                    status: status === 'ACTIVE' ? true : false,
                    startDate: dataAppointment?.startTime,
                    endDate: dataAppointment?.endTime
                };
                dispatch(giftCardsActions.getListGiftCard.fetch(payload));
            }
        } catch (error) {
            toast.error('Fail');
        } finally {
            setLoadingPage(false);
            setResetTimeChecked([]);
        }
    };

    if (versionUI === 'V2') {
        return (
            <>
                <GiftCardsStyled>
                    <Sidebar />
                    <GiftCardsV2
                        status={status}
                        setStatus={setStatus}
                        resetTime={resetTime}
                        searchText={searchText}
                        pageSize={PAGE_SIZE}
                        resetTimeChecked={resetTimeChecked}
                        setResetTimeChecked={setResetTimeChecked}
                        handleChangeResetTime={handleChangeResetTime}
                        onReset={onReset}
                        handleSearch={handleSearch}
                        setSearchText={setSearchText}
                    />
                </GiftCardsStyled>
                <Modal
                    visible={visibleConfirm}
                    onClose={() => setVisibleConfirm(false)}
                    hiddenHeader
                    v2
                    okTitle={'Reset'}
                    onSubmit={handleReset}
                    className='modal-non-opacity modal-bg-v2'
                >
                    <ModalStyled>
                        <IconWarningBig />
                        <Text variant='H7' mt={2} mb={1} style={{ fontSize: 24 }} >
                            Do you want to reset gift card?
                        </Text>
                    </ModalStyled>
                </Modal>
            </>
        );
    }

    return (
        <GiftCardsStyled>
            <Sidebar />
            <Container>
                <HeaderBox>
                    <Box pt='2'>
                        <Text variant="H5">Gift Cards ({totalElements ?? 0})</Text>
                    </Box>
                    <HeaderBox>
                        <Button disabled={!resetTimeChecked.length} icon="change" ntype='SECONDARY' onClick={onReset}>
                            Reset
                        </Button>
                        <SelectResetTimesStyled
                            placeholder="Reset Time"
                            onChange={handleChangeResetTime}
                            value={resetTime}
                            options={optionsResetTime}
                            allowClear
                        />
                        <InputStyled
                            placeholder="Search by staff,customer,card number"
                            suffix={<Icon type='search' />}
                            // @ts-ignore
                            onChange={handleSearch} />
                        <AppointmentDatePicker size='middle' actions={giftCardsActions} selectors={giftCardsSelectors} type='GIFT_CARDS' />
                        <SwitchCalendarType actions={giftCardsActions} selectors={giftCardsSelectors} type='GIFT_CARDS' />
                    </HeaderBox>
                </HeaderBox>
                <TableGiftCards
                    status={status}
                    resetTime={resetTime}
                    searchText={searchText}
                    pageSize={PAGE_SIZE}
                    resetTimeChecked={resetTimeChecked}
                    setResetTimeChecked={setResetTimeChecked}
                />
            </Container>
            <Modal
                visible={visibleConfirm}
                onClose={() => setVisibleConfirm(false)}
                hiddenHeader
                okTitle={'Reset'}
                onSubmit={handleReset}
            >
                <ModalStyled>
                    <IconWarningBig />
                    <Text variant='H7' mt={2} mb={1} >
                        Do you want to reset gift card?
                    </Text>
                </ModalStyled>
            </Modal>
        </GiftCardsStyled>
    );
};
const optionsResetTime = [
    { value: 0, label: 'All' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
];
export default GiftCards;
const GiftCardsStyled = styled(Layout)` 
    min-height: 100vh;
`;
const Container = styled(Layout)`
    background-color: ${colorTheme.fill_3};
`;
const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  padding: 0 1rem;
`;
const InputStyled = styled(Input)`
    height: 3.5rem;
    width:100%;
    display: flex;
    flex:1;
`;
const SelectResetTimesStyled = styled(SelectFromToOptions)`
    width: 150px;
    height: 3.5rem;
`;
const ModalStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const IconWarningBig = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="97" height="96" viewBox="0 0 97 96" fill="none">
        <path d="M47.1016 0.0228096C55.1129 -0.22689 63.1789 1.57766 70.3131 5.23293C80.7502 10.506 89.0973 19.7575 93.2729 30.6813C96.9722 40.1783 97.5136 50.865 94.7963 60.6872C92.5469 68.9693 88.0082 76.6156 81.8203 82.5622C75.9639 88.2318 68.624 92.355 60.7385 94.4198C51.8584 96.7699 42.2985 96.4971 33.5758 93.6119C23.9194 90.4917 15.3351 84.1821 9.45146 75.9147C5.22546 70.0184 2.37175 63.1465 1.17361 55.9933C-0.943594 43.7496 1.96467 30.7359 9.10944 20.5716C14.9679 12.1091 23.6382 5.6421 33.4163 2.43168C37.8291 0.975446 42.4538 0.14661 47.1016 0.0228096ZM46.4909 13.7206C44.5878 14.1676 42.8441 15.2692 41.6312 16.803C40.2296 18.5363 39.556 20.8171 39.7428 23.0329C40.6178 34.8842 41.4991 46.7355 42.3741 58.5868C42.4223 59.0841 42.4013 59.5982 42.544 60.085C42.7161 60.5299 43.2155 60.7292 43.6687 60.6914C46.961 60.683 50.2532 60.6998 53.5434 60.683C54.1393 60.7124 54.5883 60.1459 54.5611 59.5793C55.4654 47.3294 56.3824 35.0794 57.2784 22.8294C57.4756 19.9694 56.1642 17.0632 53.8833 15.3237C51.827 13.7122 49.0299 13.1121 46.4909 13.7206ZM46.7218 68.2957C45.2278 68.6671 43.868 69.5316 42.8923 70.7193C40.7521 73.2268 40.6933 77.2031 42.7601 79.7714C44.7682 82.4594 48.7319 83.3679 51.7095 81.8215C54.9493 80.2939 56.6027 76.1812 55.2955 72.8386C54.133 69.433 50.1945 67.3389 46.7218 68.2957Z" fill="#FFDC7C" />
    </svg>
);
